var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left"},[_vm._v("\n    Data da ultima atualização: "+_vm._s(this.dataformatada)+"\n    "),_c('b-button',{attrs:{"variant":"success","disabled":!_vm.desabilitarAtualizarnoRM},on:{"click":function($event){return _vm.confirmarAtualizar()}}},[_vm._v("Atualizar no RM\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }